import { render, staticRenderFns } from "./visitorList.vue?vue&type=template&id=84bda296&scoped=true"
import script from "./visitorList.vue?vue&type=script&lang=js"
export * from "./visitorList.vue?vue&type=script&lang=js"
import style0 from "./visitorList.vue?vue&type=style&index=0&id=84bda296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bda296",
  null
  
)

export default component.exports